const severityLevels = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
export { severityLevels };



// WEBPACK FOOTER //
// ../../core/dist/error-tracking/types.mjs